module.exports = __webpack_public_path__ + "img/all-category.eaef58a9.svg";